














import { Mixins, Component, Prop, Emit } from "vue-property-decorator";
import { QuestionnaireVariableFhirPathItem } from "../../../../../../domain/questionnaire";

@Component
export default class QuestionnaireVariableFhirPathItemSelector extends Mixins() {
  @Prop({ default: () => [] as QuestionnaireVariableFhirPathItem[] })
  options: QuestionnaireVariableFhirPathItem[];

  @Emit()
  rowClick(value: QuestionnaireVariableFhirPathItem) {}
}
